import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { showSnackbar } from '../../../../actions/appActions';
import withErrorCatcher from '../../../components/Common/withErrorCatcher';


// Apply some reset
const styles = theme => ({
});


class ChangeUsersQuantityModal extends PureComponent {

    state = {
        usersNumber: 1,
        isSaving: false,
    }

    onChange = (event) => {
        this.setState({ usersNumber: event.target.value })
    }

    handleQuantitySave = () => {
        const { dispatch, billingService, onClose } = this.props;

        this.setState({ isSaving: true })
        billingService.updateUsersCount(this.state.usersNumber).then(() => {
            dispatch(showSnackbar('Saved!'));
            this.setState({ isSaving: false })
            onClose()
        })
        dispatch(showSnackbar('Saving...'));

    }

    userCost = (usersNumber) => {
        let usersCost = 0;
        const { currentSubscriptionType } = this.props
        if (currentSubscriptionType === 1) {
            usersCost = usersNumber * 9
        } else if (currentSubscriptionType === 2) {
            usersCost = usersNumber * 19
        }

        return usersCost;


    }


    render() {
        const { open, onClose,t } = this.props;
        const { usersNumber, isSaving } = this.state;

        return (
            <Dialog

                // onEnter={this.initText}
                maxWidth={'xs'}
                open={open}
                onRequestClose={onClose}>
                <DialogTitle>{t('Get more users')}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Typography variant="body1">{t('Add more users')}</Typography>
                    </DialogContentText>
                    <TextField
                        id="standard-number"
                        label={t("New users")}
                        value={usersNumber}
                        onChange={this.onChange}
                        type="number"
                        helperText={t("New users")}

                        InputLabelProps={{
                            shrink: true,
                        }}
                        margin="normal"
                    />
                    <Typography>
                        {`${t('Adding')} ${usersNumber} ${t('user(s) will add ')}${this.userCost(usersNumber)}$ ${t('to your monthly bill')}.
                        ${t('You are adding users in the middle of the subscription period')}.${t('We will update the next invoice, and apply the remaining in a special invoice')}.`}
                    </Typography>

                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary">
                        {t("Cancel")}
           </Button>
                    <Button onClick={this.handleQuantitySave} disabled={isSaving} color="primary">
                        {t('Update')}
           </Button>
                </DialogActions>
            </Dialog>)
    }




}


const mapStateToProps = (state) => ({

    ...state.services
})

const mapDispatchToProps = dispatch => ({ dispatch })

export default compose(withStyles(styles),
    withTranslation('admin'),
    withErrorCatcher(),
    connect(
        mapStateToProps,
        mapDispatchToProps
    ))(ChangeUsersQuantityModal);

